export type BreathingStyle = 'circle' | 'line';

export const DEFAULT_BREATHING_STYLE: BreathingStyle = 'circle';

export const BREATHING_STYLE_LABELS: Record<BreathingStyle, string> = {
  circle: 'Circle',
  line: 'Line',
};

export interface BreathingStyleOption {
  value: BreathingStyle;
  label: string;
  description: string;
}

export const BREATHING_STYLE_OPTIONS: BreathingStyleOption[] = [
  {
    value: 'circle',
    label: 'Circle',
    description: 'Radiant orb that expands and contracts with each breath.',
  },
  {
    value: 'line',
    label: 'Line',
    description: "Flowing horizon line inspired by Prana Breath's line mode.",
  },
];

export const isBreathingStyle = (value: unknown): value is BreathingStyle =>
  value === 'circle' || value === 'line';

export const normalizeBreathingStyle = (
  value: unknown,
  fallback: BreathingStyle = DEFAULT_BREATHING_STYLE
): BreathingStyle => (isBreathingStyle(value) ? value : fallback);
